import { cn } from "@/lib/utils";

interface SpecialAttributeChipProps {
  name: string;
  color?: string;
  onRemove?: () => void;
  className?: string;
}

export function SpecialAttributeChip({
  name,
  color,
  onRemove,
  className,
}: Readonly<SpecialAttributeChipProps>) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-medium text-white",
        className,
      )}
      style={color ? { backgroundColor: color } : undefined}
      title={name}
    >
      {name}
      {onRemove ? (
        <button
          type="button"
          aria-label={`Remove ${name}`}
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          className="ml-0.5 rounded-full px-1 hover:bg-black/20"
        >
          ×
        </button>
      ) : null}
    </span>
  );
}
